import type { UploadFile } from 'antd';

const getFileSizeLabel = (size = 0) => {
  if (size < 1024 * 1024) return `${Math.max(1, Math.round(size / 1024))} KB`;
  return `${(size / 1024 / 1024).toFixed(1)} MB`;
};

export const getFileMetaLabel = (file: UploadFile) => {
  const extension = file.name.split('.').pop()?.toUpperCase();
  return `${extension} · ${getFileSizeLabel(file.size)}`;
};
